import {
    getAdminProfileAPI,
    applyLeaveAPI,
    getLeaveCalendarAPI,
    getUpcomingLeavesAPI,
    getMyLeavesAPI,
    cancelLeaveAPI,
    getBlockedDatesAPI,
    getPendingLeaveRequestsAPI,
    reviewLeaveAPI
} from "./api"

export function getAdminProfile() {
    return new Promise((resolve, reject) => {
        getAdminProfileAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}

export function applyLeave(data) {
    return new Promise((resolve, reject) => {
        applyLeaveAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getLeaveCalendar() {
    return new Promise((resolve, reject) => {
        getLeaveCalendarAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getUpcomingLeaves() {
    return new Promise((resolve, reject) => {
        getUpcomingLeavesAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getMyLeaves() {
    return new Promise((resolve, reject) => {
        getMyLeavesAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}

export function cancelLeave(data) {
    return new Promise((resolve, reject) => {
        cancelLeaveAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getBlockedDates() {
    return new Promise((resolve, reject) => {
        getBlockedDatesAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getPendingLeaveRequests() {
    return new Promise((resolve, reject) => {
        getPendingLeaveRequestsAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}

export function reviewLeave(data) {
    return new Promise((resolve, reject) => {
        reviewLeaveAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}
